module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor26.b2db68bb.png";